import { take, filter, skip } from 'rxjs/operators';
import { Router, NavigationStart } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { TransferState, makeStateKey } from '@angular/core';
import { Platform } from '@angular/cdk/platform';

export const STATE_KEY = makeStateKey<any>('expo.state');

@Injectable({
  providedIn: 'root'
})
export class FromServerService {
  platform = inject(Platform);
  router = inject(Router);
  transferState = inject(TransferState);
  constructor(
    ) {
    if(this.platform.isBrowser) {
      this.router.events
      .pipe(
        filter(e => e instanceof NavigationStart),
        skip(1),
        take(1)
      )
      .subscribe(() => {
        this.transferState.remove(STATE_KEY);
      });
    }
  }

  get isFromServer(): boolean {
      return this.transferState.hasKey<any>(STATE_KEY);
  }

}
